// extracted by mini-css-extract-plugin
export default {"profile-paper":"Avatar_profile-paper__VbDvm","sign-out":"Avatar_sign-out__9tdAy","app-row":"Avatar_app-row__TnBVe"};